// Visit-category presentation for the doctor cockpit's pre-visit intake recall. Pure mapping (label +
// badge icon + tone class) so a dental/vision intake reads differently from a medical one. Unknown /
// missing values normalize to "medical" (older intake rows predate the category column).
export type VisitCategory = "medical" | "dental" | "vision";

export const CATEGORY_LABEL: Record<VisitCategory, string> = {
  medical: "Medical",
  dental: "Dental",
  vision: "Vision",
};

// Inner SVG markup (wrapped by the caller). Ported from the shared intake icon set.
export const CATEGORY_ICON: Record<VisitCategory, string> = {
  medical: '<path d="M6 3H5v4a4 4 0 0 0 8 0V3h-1"/><path d="M9 15a5 5 0 0 0 5 5 4 4 0 0 0 4-4v-1.5"/><circle cx="18.5" cy="13" r="2"/>',
  dental:
    '<path d="M8 3.5C6 3.5 4.5 5 4.5 7.2c0 1.3.4 2.2.6 3.6.3 2.2.3 4.4 1 6.6.4 1.3.7 2.6 1.4 2.6.8 0 .8-1.6 1-3 .2-1.2.4-2 1.5-2s1.3.8 1.5 2c.2 1.4.2 3 1 3 .7 0 1-1.3 1.4-2.6.7-2.2.7-4.4 1-6.6.2-1.4.6-2.3.6-3.6C16.5 5 15 3.5 13 3.5c-1.1 0-1.7.5-2.5.5S9.1 3.5 8 3.5z"/>',
  vision: '<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/>',
};

/** Coerce any string (incl. undefined / legacy rows) to a known category, defaulting to medical. */
export function normalizeCategory(value: string | null | undefined): VisitCategory {
  return value === "dental" || value === "vision" ? value : "medical";
}
